import React, { useRef, useState } from "react";
import { useUser } from "../../../custom-hooks/useUser";
import { Button, Card, CardBody, CardHeader, CardTitle, Label, Row } from "reactstrap";
import ReactTable from "react-table";
import axios from "axios";
import { routes } from "../../../gen/General";
import Alerts from "../../../util/Alerts";
import moment from "moment/moment";

export const MailZerobounce = () => {
    const user = useUser().usuario;
    const [mailData, setMailData] = useState({
        list: [],
        page: 0,
        loading: false,
        number: 0,
        size: 0,
        total: 0,
        pages: -1,
    });
    const [query, setQuery] = useState({
        mail: "",
        userCreator: user,
        creationDate: new Date(),
    });
    const alert = useRef();

    const fetchDate = values => {
        setMailData({ ...mailData, loading: true });
        axios
            .post(`${routes.api}/mail-zerobounce/`, {
                ...query,
                page: values.page,
                pageSize: values.pageSize,
            })
            .then(res => {
                setMailData({
                    list: res.data.content,
                    pages: res.data.totalPages,
                    loading: false,
                    number: res.data.number,
                    size: res.data.size,
                    total: res.data.totalElements,
                });
            })
            .catch(alert.current.handle_error);
    };

    const saveEmailZerobounceData = () => {
        axios
            .post(`${routes.api}/mail-zerobounce/save-mail`, {
                emailZerobounce: query,
            })
            .then(() => {
                setQuery({ ...query, mail: "" });
                fetchDate({ page: 0, pageSize: 10 });
            })
            .catch(alert.current.handle_error);
    };

    const deleteData = id => {
        axios
            .post(`${routes.api}/mail-zerobounce/delete-mail`, {
                id: id,
            })
            .then(() => {
                fetchDate({ page: 0, pageSize: mailData.size });
            })
            .catch(alert.current.handle_error);
    };

    function indexTable(row) {
        return <span>{mailData.number * mailData.size + (row.index + 1)}</span>;
    }

    function dateFormatColumn(row) {
        return <span>{moment(row.value).format("dd/MM/YYYY")}</span>;
    }

    function deleteButtonColumn(row) {
        return (
            <i className="fa fa-trash" aria-hidden="true" onClick={() => deleteData(row.original.idEmailZerobounce)} />
        );
    }

    return (
        <div className="content">
            <Alerts ref={alert} />
            <Card>
                <CardHeader>
                    <CardTitle tag={"h4"}>Mail Zerobounce Registrados</CardTitle>
                </CardHeader>
                <CardBody>
                    <div className={"container-fluid"}>
                        <Row>
                            <div className={"form-group col-lg-6"}>
                                <Label>Mail:</Label>
                                <input
                                    value={query.mail}
                                    placeholder={"Ingrese el mail a registrar ..."}
                                    className={"form-control primary"}
                                    onChange={e => setQuery({ ...query, mail: e.target.value })}
                                />
                            </div>
                            <div className={"form-group col-lg-6"}>
                                <Button
                                    type={"submit"}
                                    color="primary"
                                    className="mx-md-4 my-md-4"
                                    onClick={() => saveEmailZerobounceData()}
                                >
                                    Agregar
                                </Button>
                            </div>
                        </Row>
                        <br />
                        <Row>
                            <div className={"col-md-12"}>
                                <ReactTable
                                    noDataText={"No se encontraron registros..."}
                                    loadingText={"Cargando..."}
                                    rowsText={"filas"}
                                    ofText={"de"}
                                    previousText={"Anterior"}
                                    nextText={"Siguiente"}
                                    pageText={"Página"}
                                    columns={[
                                        {
                                            Header: "#",
                                            accessor: "idEmailZerobounce",
                                            Cell: row => {
                                                return indexTable(row);
                                            },
                                            width: 60,
                                            filterable: false,
                                            sortable: false,
                                        },
                                        {
                                            Header: "Mail",
                                            accessor: "email",
                                            filterable: false,
                                            sortable: false,
                                        },
                                        {
                                            Header: "Usuario",
                                            accessor: "creatorUser",
                                            filterable: false,
                                            sortable: false,
                                        },
                                        {
                                            Header: "Fecha de Creación",
                                            accessor: "creationDate",
                                            filterable: false,
                                            sortable: false,
                                            Cell: row => {
                                                return dateFormatColumn(row);
                                            },
                                        },
                                        {
                                            Header: "Eliminar",
                                            filterable: false,
                                            sortable: false,
                                            Cell: row => {
                                                return deleteButtonColumn(row);
                                            },
                                        },
                                    ]}
                                    manual
                                    data={mailData.list}
                                    page={mailData.number || 0}
                                    pages={mailData.pages}
                                    loading={mailData.loading}
                                    defaultPageSize={10}
                                    onFetchData={state => fetchDate(state)}
                                    filterable
                                    className={"-striped -highlight"}
                                    showPagination
                                ></ReactTable>
                            </div>
                        </Row>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};
